import React from "react";
import styles from "../styles/PrivayPolicyStyle.module.css";
import { Container, Row } from "reactstrap";

const PrivacyPolicy = () => {
  return (
    <div className={styles.content}>
      <div className={styles.backdrop}>
        <Container style={{ border: "2px solid transparent" }}>
          <h4 className="fw-bolder py-5 text-center">
            Easy Freight International Logistics Company Privacy Policy
          </h4>
          <p>
            This Website is operated by EasyFreight International Logistics Co.,
            Ltd. Please read these terms and conditions of use before using our
            services.
          </p>
          <div className="my-5">
            <span className="fw-bolder">
              1. Collection of Personal Information
            </span>
            <div className={styles.divider}></div>
            <p className="mt-3">
              We will collect and process your personal information (regardless
              of electronic or non-electronic information) lawfully, fairly and
              in a transparent manner only to the extent necessary for providing
              our services or performing our contractual obligations.
            </p>
          </div>
          <div className="my-5">
            <span className="fw-bolder">2. Data Minimization</span>
            <div className={styles.divider}></div>
            <p className="mt-3">
              We will keep personal information adequate, relevant and limited
              to what is necessary in relation to the purpose for which it was
              provided. We will not collect personal information in advance or
              store personal information for future purposes, unless required or
              permitted by laws or regulations.
            </p>
          </div>
          <div className="my-5">
            <span className="fw-bolder">
              3.Intended Use of Personal Information
            </span>
            <div className={styles.divider}></div>
            <p className="mt-3">
              We will only use the personal information for one or more
              specified and legitimate purposes. Personal information will not
              be used or processed in any manner incompatible with those
              purposes. When we need to use your personal information beyond the
              scope of such purposes, we shall obtain your consent, except when
              extended use would be permitted by laws or regulations.
            </p>
          </div>
          <div className="my-5">
            <span className="fw-bolder">4. Accuracy</span>
            <div className={styles.divider}></div>
            <p className="mt-3">
              We will keep personal information accurate and up-to-date and
              shall take all reasonable steps to ensure that personal
              information that is inaccurate will be removed or rectified
              without delay.
            </p>
          </div>
          <div className="my-5">
            <span className="fw-bolder">5. Limited Retention</span>
            <div className={styles.divider}></div>
            <p className="mt-3">
              We will keep personal information no longer than is necessary for
              the purposes for which the personal information was provided.
              Unless otherwise permitted by laws and regulations, personal
              information that is no longer needed or relevant will be purged or
              deleted.
            </p>
          </div>
          <div className="my-5">
            <span className="fw-bolder">
              6. Management of Personal Information
            </span>
            <div className={styles.divider}></div>
            <p className="mt-3">
              Your personal information is subject to data secrecy. In managing
              personal information, we assign an officer in charge of handling
              personal information, and take appropriate and adequate protective
              measures on a technical and organizational level against
              unauthorized or unlawful use and processing.
            </p>
          </div>
          <div>
            <span className="fw-bolder">7. Provision to Third Parties</span>
            <div className={styles.divider}></div>
            <p className="mt-3">
              Unless otherwise permitted by laws and regulations, we will not
              provide your personal information to any third party without your
              consent. In addition, your personal information will not be
              transferred to another country or territory unless that country or
              territory will ensure an adequate level of data protection.
            </p>
          </div>
        </Container>
      </div>
    </div>
  );
};
export default PrivacyPolicy;
